export function extractVersionFromXmlContent(xmlContent: string): string {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlContent.trim(), 'text/xml');

  const id = xmlDoc.getElementsByTagName('id')[0]?.textContent || '';
  const hardware = xmlDoc.getElementsByTagName('hardware')[0]?.textContent || '';
  const major = xmlDoc.getElementsByTagName('major')[0]?.textContent || '';
  const minor = xmlDoc.getElementsByTagName('minor')[0]?.textContent || '';
  const develop = xmlDoc.getElementsByTagName('develop')[0]?.textContent || '';

  return `${id}-${hardware},${major}.${minor}.${develop}`;
}
